<div class="relative h-full pointer-events-auto overflow-y-auto bg-white">
    <home-hero-section/>
    <home-we-are-planmeister />
    <home-pillars />
    <app-home-testimonial-section/>
    <app-home-cta-section />
    <home-contact />
    <shell-footer/>
</div>
